import React, {useState} from 'react';
import {Box, Button, Grid, IconButton, TextField, Typography} from "@mui/material";
import logo from '../../../assets/images/logo.png';
import {Instagram, Telegram, WhatsApp} from "@mui/icons-material";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import {subscribeUserApi} from "../../../api/ClientApi";
import {fixStringToTextView, numOnKeyDown} from "../../../tools/helper";
import {errorMessage, successMessage} from "../../../tools/messages";
import {GetState} from "../../../redux/reduxhelper";
import {IS_AUTH} from "../../../redux/action/type.action";
import {useNavigate} from "react-router";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const Footer = () => {
    const defData = {
        fullname: "",
        mobile: "",
        email: ""
    };
    const isAuth = GetState(IS_AUTH, false)
    const navigate = useNavigate();
    const [formData, setFormData] = useState(defData)

    const subscribeUser = async () => {
        try {
            let res = await subscribeUserApi(formData);
            console.log(res?.data);
            successMessage('با موفقیت انجام شد')
            setFormData(defData)
        } catch (e) {
            errorMessage('خطا در انجام عملیات')
        }
    }

    return (
        <>
            <Box sx={{background: "#232536", color: "#fff",width:"100%"}}>
                <Grid sx={{mx: 8, my: 4}}>
                    <img src={logo} alt="logo"/>
                </Grid>
                <Box sx={{background: "#333546", mx: 8}}>
                    {isAuth && <Grid sx={{textAlign: "right"}}>
                        <IconButton  sx={{mr:2,mt:1,color: "#FFD050", cursor: "pointer"}}
                                     onClick={() => navigate('admin/dashboard/subscribers')}>
                            <EditOutlinedIcon/>
                        </IconButton>
                    </Grid>}
                    <Grid container sx={{
                        display: "flex",
                        flexDirection: {xs: "column", md: "row"},
                        justifyContent: "space-around",
                        alignItems: "center",
                        padding:2
                    }}>
                        <Grid sx={{my: 7}}>
                            <Typography variant={"h6"} sx={{fontWeight: 800, textAlign: {xs: "center", md: "left"}}}>
                                برای کسب اطلاعات بیشتر اطلاعـات خود را وارد <br/>کنید و در اولـین فـرصت کـارشناسان ما با
                                شمـا <br/>تماس می گیرند.
                            </Typography>
                        </Grid>
                        <Grid sx={{display: "flex", flexDirection: "column",gap:1}}>
                            <TextField
                                value={fixStringToTextView(formData?.fullname)}
                                onChange={(e) => setFormData({...formData, fullname: e.target.value})}
                                inputProps={{sx: {color: '#efff0c'}}}
                                sx={{background: "#686a83",'.MuiInputLabel-formControl':{color:"#f5ffde !important"}}}
                                variant="filled"
                                required
                                id="filled-basic"
                                label="نام و نام خانوادگی"
                            />
                            <TextField
                                inputProps={{sx: {color: '#efff0c'}}}
                                sx={{background: "#686a83",'.MuiInputLabel-formControl':{color:"#f5ffde !important"}}}
                                value={formData?.mobile}
                                type={'number'}
                                onKeyDown={numOnKeyDown}
                                onChange={(e) => setFormData({...formData, mobile: e.target.value})}
                                variant="filled"
                                required
                                id="filled-basic"
                                label="شماره همراه"
                            />
                            <TextField
                                inputProps={{sx: {color: '#efff0c'}}}
                                sx={{background: "#686a83",'.MuiInputLabel-formControl':{color:"#f5ffde !important"}}}
                                value={fixStringToTextView(formData?.email)}
                                onChange={(e) => setFormData({...formData, email: e.target.value})}
                                variant="filled"
                                required
                                id="filled-basic"
                                label="ایمیل"

                            />
                        </Grid>
                        <Grid>
                            <Button sx={{
                                background: "#FFD050",
                                color: "#232536",
                                padding: "15px 50px",
                                fontSize:{xs:'12px',sm:'12px'},
                                fontWeight: "700",
                                mb: {xs: 3},
                                mt: {xs: 3,md:0},
                                '&:hover': {
                                    backgroundColor: '#d26e4b',
                                }
                            }} onClick={subscribeUser} variant={"contained"}>ثبت</Button>

                        </Grid>

                    </Grid>

                </Box>
                <Grid sx={{textAlign: "center"}}>
                    <Box sx={{
                        my: 1, "& svg": {
                            fontSize: "40px",
                            cursor: "pointer",
                            mr: 2
                        },
                        "& svg:hover": {
                            color: "goldenrod",
                            transform: "translateX(5px)",
                            transition: "all 400ms"
                        }
                    }}>
                        <Instagram/>
                        <LinkedInIcon/>
                        <WhatsApp/>
                        <Telegram/>

                    </Box>
                    <Typography variant="h6" sx={{
                        textAlign: "center", '@media(max-width:600px)': {
                            fontSize:{xs:'12px',sm:'12px'}
                        }
                    }}>
                        All Right Reserved &copy; shadzi
                    </Typography>
                </Grid>

            </Box>
        </>
    );
};

export default Footer;